import placeTree from './placeTree'
import tree from './tree'
import permissionTree from './permissionTree'
import confirmDialog from './confirmDialog'
import upload from './upload'

export default {
  install (Vue, options) {
    Vue.use(tree)
    Vue.use(placeTree)
    Vue.use(permissionTree)
    Vue.use(confirmDialog)
    Vue.use(upload)
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js